export function toLanguageCode(locale: string): string {
  return locale.split('-')[0];
}

export const DEFAULT_LOCALE = 'en-US';
export const PREFIXES = {
  '/en': 'en-US',
  '/de': 'de-DE',
  '/es': 'es-ES',
  '/fr': 'fr-FR',
  '/it': 'it-IT',
  '/ru': 'ru-RU',
  '/tr': 'tr-TR',
  '/nl': 'nl-NL',
  '/pt': 'pt-PT',
} as const;

const PREFIX_KEYS = Object.keys(PREFIXES) as (keyof typeof PREFIXES)[];

export const getPrefix = (locale: string) => {
  return PREFIX_KEYS.find(key => locale && PREFIXES[key].startsWith(locale));
};

// robots.txt disallows /en/, so English URLs must stay unprefixed to be indexed
export const getIndexablePrefix = (locale: string) =>
  toLanguageCode(locale) === toLanguageCode(DEFAULT_LOCALE)
    ? ''
    : getPrefix(locale);

const PREFIX_RE = new RegExp(`(${PREFIX_KEYS.filter(Boolean).join('|')})(/|$)`);

export const stripPrefix = (url: string) => {
  return url.replace(PREFIX_RE, '/');
};

const AVAILABLE_LOCALES = Object.values(PREFIXES);

const AVAILABLE_LANGUAGES = AVAILABLE_LOCALES.map(toLanguageCode);
export const ALLOWED_LOCALES = AVAILABLE_LANGUAGES.concat(AVAILABLE_LOCALES);

export type GenericLanguage =
  | 'en'
  | 'de'
  | 'es'
  | 'fr'
  | 'it'
  | 'ru'
  | 'tr'
  | 'nl'
  | 'pt';

export type AvailableLanguage =
  | GenericLanguage
  | (typeof AVAILABLE_LOCALES)[number];
